import React from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';

export const Item = ({url, name, logoUri, slogan, description, hasAccount, portalUrl}) => {
    // console.log(name, hasAccount)
    return (
        <div className="col">
            {/* <!-- Card --> */}
            <div className={"card border-light flex-fill" + (hasAccount ? " bg-none" : " bg-common")}>
                <div className="card-header flex-row align-items-center gap-2">
                    { R.isNotNil(logoUri) ?
                        <img className="w-auto container-tight rounded-1 bg-body p-1" height="28" src={logoUri} alt="Avatar Logo"  style={{aspectRatio: "1", objectFit: "contain"}}/>
                        : ''
                    }
                    <div className="flex-row flex-fill justify-content-between py-1">
                        <h5 className="h5 fw-bold mb-0">{name}</h5>
                        <div className="dropdown ms-auto" data-bs-toggle="dropdown" aria-expanded="false">
                            <Link to="#" className="action-item">
                                <i className="icns mdi mdi-dots-horizontal text-lg"></i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-end shadow-lg p-1">
                                <Link to="/services" className="dropdown-item rounded-2">Refresh</Link>
                                <a className="dropdown-item rounded-2 px-lg-3 w-100 text-left" target="blank" href={"mailto:support@securibox.eu?Subject=Securibox%20Accounts%20-%20" + name + "%20[Feedback]"} tabIndex={-1} aria-disabled="true">Feedback</a>
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="card-body flex-column flex-fill gap-4">
                    <div className="flex-column flex-fill gap-1">
                        <div className="flex-row align-items-center justify-content-between gap-2">
                            <p className="d-block text-inherit fw-medium mb-0">{slogan}</p>
                            { R.isNotNil(slogan) && <i className="icns mdi mdi-star text-info ml-2 text-lg"></i> }
                        </div>
                        <p className="text-muted fs-aux mb-auto">{description || (name.startsWith('Securibox') ? name : ("Securibox " + name))}</p>
                    </div>

                    <div className="btn-group bg-common w-100 mt-auto" role="group" aria-label="First group">
                        <a href={url || "#"} target="_blank" className="btn fs-sm btn-alert-primary text-body py-1 lh-copy px-2" rel="noreferrer"><i className="icns mdi mdi-earth text-primary fs-lg mr-2"></i>Website</a> 
                        { hasAccount ?
                            <a type="button" href={!R.isNil(portalUrl) ? portalUrl : false} target="_blank" className="btn btn-primary fs-sm py-1 lh-copy px-2" rel="noreferrer"><i className="icns mdi mdi-open-in-new fs-lg mr-2"></i>Go <span className="d-none d-lg-inline-block">to app</span></a> 
                            : ''
                        }
                    </div>
                </div>
            </div>
            {/* <!-- End Card --> */}
        </div>
    );
}